import { FC, useState } from 'react';
import { X } from 'phosphor-react';
import LogoSAMI from '../../images/sami_logo.svg';
import { LanguageDropdown } from './LanguageDropdown';
import { BrevFranOssContent, ShopContent } from '../../types/cms_shared_types';
import { ConfirmationDialog } from '../Webshop/ConfirmationDialog';

interface HeaderProps {
  title?: string;
  cmsContent?: ShopContent | BrevFranOssContent;
}

export const Header: FC<HeaderProps> = ({ title, cmsContent }) => {
  const [showLeavePageModal, setShowLeavePageModal] = useState(false);

  return (
    <div className="sticky top-0 z-10 flex flex-row items-center w-full h-16 bg-white shadow-md">
      <div className="flex-1">
        <div className="flex flex-row items-center" onClick={() => setShowLeavePageModal(true)}>
          <div className="w-16 h-16 p-4 bg-sami-green">
            <X size={32} className="text-white" />
          </div>
          <img src={LogoSAMI} alt="sami-logo" />
        </div>
      </div>
      <div className="self-center flex-1 hidden text-sm font-bold text-center sm:block text-gray">
        {title?.toUpperCase()}
      </div>
      <div className="flex-1 text-right">
        <div className="mr-4">
          <LanguageDropdown cmsContent={cmsContent} />
        </div>
      </div>
      {cmsContent && (
        <ConfirmationDialog
          cmsContent={cmsContent}
          showModal={showLeavePageModal}
          setShowModal={setShowLeavePageModal}
          title={cmsContent.leavePageConfirmation.title}
          description={cmsContent.leavePageConfirmation.description}
          onYesCallback={() => {
            window.location.href = 'https://www.sami.se/';
          }}
        />
      )}
    </div>
  );
};
